// Removed incorrect import of Error icon
import { customerApi } from "../api/CustomerApi";
import { Customer } from "../models/customers/CustomerModel";

class CustomerManager {
  private static instance: CustomerManager;

  public static get(): CustomerManager {
    if (!this.instance) {
      this.instance = new CustomerManager();
    }
    return this.instance;
  }

  async getAllCustomers(): Promise<Customer[] | undefined> {
    const result = await customerApi.getAllCustomers.requestHard(null);
    if (!result || !result.data) return [];
    return result.data.map((item: any) => new Customer(item));
  }

  async updateOrCreateCustomer(
    customer: Customer
  ): Promise<boolean | undefined> {
    const result = await customerApi.updateOrCreateCustomer.request({
      customer,
    });
    return result.isSuccess;
  }

  async deleteCustomer(customer: Customer): Promise<boolean | undefined> {
    const result = await customerApi.deleteCustomer.request({ customer });
    return result.isSuccess;
  }
}

export const customerManager = CustomerManager.get();
